import { useNavigation } from "@react-navigation/native";
import React from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { ChatIcon, HomeIcon, ProfileIcon } from "../assets/icons";
import BuildingIcon from "../assets/icons/BuildingIcon";

function BottomNavigation(props) {
  const { activeIndex, setCurrentTime } = props;
  const { t } = useTranslation();
  const navigation = useNavigation();
  return (
    <>
      <View style={styles.parent}>
        {[
          { id: "home", title: "Beranda", icon: HomeIcon, path: "Home" },
          { id: "chat", title: "Chat", icon: ChatIcon, path: "Chat" },
          { id: "city", title: "Kota", icon: BuildingIcon, path: "Kota" },
          {
            id: "profile",
            title: "Profile",
            icon: ProfileIcon,
            path: "Profile",
          },
        ].map((item, index) => (
          <TouchableOpacity
            onPress={() => {
              if (setCurrentTime) {
                setCurrentTime(new Date().getTime());
              }

              navigation.navigate(item.path, {
                newTime: new Date().getTime(),
              });
            }}
            style={styles.menus}
            key={index}
          >
            <item.icon isActive={activeIndex === index} />
            <Text
              style={
                activeIndex === index ? styles.textMenuActive : styles.textMenu
              }
            >
              {t("bottom-nav:" + item.id)}
            </Text>
          </TouchableOpacity>
        ))}
      </View>
    </>
  );
}
const styles = StyleSheet.create({
  parent: {
    backgroundColor: "#fff",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
  },
  menus: {
    width: "25%",
    alignItems: "center",
    justifyContent: "center",
    padding: 12,
    flexDirection: "column",
  },
  textMenu: {
    fontFamily: "Archivo-Medium",
    fontStyle: "normal",
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 13,
    color: "#000000",
    marginTop: 6,
  },
  textMenuActive: {
    fontFamily: "Archivo-Bold",
    fontStyle: "normal",
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 13,
    color: "#6724E2",
    marginTop: 4,
  },
});
export default BottomNavigation;
